export type JwtTokenData = {
    sub?: string;
    exp?: number;
};

export default function decodeJwtToken(token: string): JwtTokenData {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');

    // Deserialization boundary: the payload is produced by the backend that signed the token.
    return JSON.parse(window.atob(base64)) as JwtTokenData;
}
